module.exports = __webpack_public_path__ + "img/survey-3.464c21f0.png";